import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from "./common/libs/store";

import "moment/locale/es";
import './i18n';

// Adding bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";

import './index.scss';

import AppRoutes from './app/app-routes';
// import reportWebVitals from './reportWebVitals';

// Blueprintjs
import "@blueprintjs/core/lib/css/blueprint.css"
import "@blueprintjs/icons/lib/css/blueprint-icons.css"
import "@blueprintjs/popover2/lib/css/blueprint-popover2.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css"
import { FocusStyleManager } from "@blueprintjs/core";
// Prevent outline borders when click on blueprint components
FocusStyleManager.onlyShowFocusOnTabs();

// Redux store
const store = configureStore();

ReactDOM.render(
  // <React.StrictMode>
      <Provider store={store}>
          <AppRoutes />
      </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
